<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { get, intersection } from 'lodash';

export default {
  mixins: [fandomBasicMixin],
  props: {
    ignoreUserTarget: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeItem: null,
    };
  },
  methods: {
    getUrl(url, parameter="icmp") {
      if (!url) {
        return 'javascript:void(0)';
      }
      if (url.includes("?")) {
        return `${url}&${parameter}=MMD`;
      } else {
        return `${url}?${parameter}=MMD`;
      }
    },
    logOutTracking(item) {
      if (!!item.url && item.url.url.includes('sign_out'))
        VodafoneLab.addDigitalDataEvent("logout", "user", ":Logout");
    },
    canShowUserItem(item) {
      if (!item.access_contents) return true;
      return intersection(get(this, ["pageModel","user","contents"], []), item.access_contents).length > 0;
    },
    isItemHidden(item) {
      return (!Fandom.isUserRegistered() &&  item.hide_to_anonymous_user) || (Fandom.isUserRegistered() && item.hide_to_registered_user);
    }
  },
  computed: {
    isProfileMenu() {
      return this.content.name === 'profile-menu';
    },
    userTarget() {
      return get(globalState, ["pageModel", "user", "target", 0], false);
    },
    items() {
      if (this.isProfileMenu) return this.content.navbar_items;
      const globalItems = this.content.navbar_items;
      if (!this.userTarget || this.ignoreUserTarget) {
        return globalItems;
      } else {
        const targetPageName = this.userTarget.split('target-')[1];
        const targetNavRecord = globalItems.find(item => (item.url?.content ?? {}).includes(targetPageName));
        return targetNavRecord?.items ?? [];
      }
    }
  },
};
</script>

<template>
  <div class="position-fixed" mobile-menu-component>
    <div class="menu position-absolute">
      <div class="close-icon position-absolute" @click="$emit('close')">
        <i class="fal fa-times"></i>
      </div>
      <div class="d-flex flex-column h-100">
        <div class="flex-grow-1 navbar-items d-flex flex-column justify-content-center px-3">
          <component
            :is="!!item.url && !item.items ? 'a' : 'div'"
            v-for="(item, index) in (items || []).filter(i => canShowUserItem(i) && !isItemHidden(i))"
            :key="`navbar-item-${index}`"
            class="h4 py-2 font-weight-normal mb-0 d-flex justify-content-between align-items-center"
            @click="() => {
              activeItem = item;
              logOutTracking(item);
            }"
            :class="!!item.items && item.items.length > 0 && isProfileMenu ? 'text-primary' : 'text-black'"
            :href="getUrl((item.url || {}).url)"
            :target="getTarget(item.url)"
          >
            <span :style="{'color': item.color}" class="py-2">{{item.title || item.url.title}}</span>
            <i v-if="!!item.items && item.items.length > 0 && isProfileMenu" class="fal fa-chevron-right ml-2"></i>
          </component>
        </div>
        <div class="gray-navbar-items flex-shrink-1 mb-3 pb-3" v-if="content.navbar_top">
          <div v-for="(item, index) in content.navbar_top" :key="`navbar-top-item-${index}`" class="mx-4">
            <a
              :href="getUrl(item.url.url, 'ecmp')"
              :target="getTarget(item.url, 'ecmp')"
              class="cursor-pointer d-flex justify-content-between align-items-center py-3"
            >
              <span class="text-black">{{item.url.title}}</span>
              <i class="fal fa-chevron-right ml-2"></i>
            </a>
          </div> 
        </div>
        <div class="profile-section bg-primary flex-shrink-1 px-3 py-4 d-flex align-items-center" v-if="isProfileMenu && !!getContent(userTarget)">
          <div class="target-icon bg-white rounded-circle d-flex justify-content-center align-items-center mr-3" v-if="getContent(userTarget).profile_icon">
            <img :src="getContent(userTarget).profile_icon.url" class="image-fluid"/>
          </div>
          <div class="py-2">
            <div class="text-white font-weight-normal mb-0 target-text">
              {{pageModel.user.username}}
            </div>
            <div class="text-white small target-text">
              {{getContent(userTarget).title}}
            </div>
            <div class="text-white target-text last-sign-in-at">Ultimo accesso {{ pageModel.user.last_sign_in_at }}</div>
          </div>
        </div>
      </div>
    </div>
    <transition enter-active-class="animated faster slideInLeft" leave-active-class="animated faster slideOutLeft">
      <div class="menu position-absolute d-flex flex-column justify-content-center" v-if="activeItem && activeItem.items">
        <div class="back-icon position-absolute" @click="activeItem = null">
          <i class="fal fa-arrow-left"></i>
        </div>
        <div v-for="(item, index) in (activeItem.items || []).filter(i => canShowUserItem(i) && !isItemHidden(i))" :key="`navbar-top-item-${index}`" class="mx-4 navbar-link-container">
          <a
            class="cursor-pointer d-flex justify-content-between align-items-center py-3"
            :href="getUrl(item.url.url)"
            :target="getTarget(item.url)"
          >
            <span class="text-black">{{item.url.title}}</span>
            <i class="fal fa-chevron-right ml-2"></i>
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
[mobile-menu-component] {
  top: $header-height-sm;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;

  .menu {
    background-color: white;
    top: 0;
    left: 0;
    bottom: 0;
    width: calc(100% - 3.5rem);
    border-bottom-right-radius: 16px;

    .close-icon,
    .back-icon  {
      width: 3.5rem;
      height: 3.5rem;
      top: 0;
      padding: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;

      & > i {
        line-height: 1.5rem;
        @include font-size(1.5rem);
      }
    }

    .close-icon {
      left: 100%;
      color: white;
    }
    
    .back-icon {
      left: 0;
      color: $black;
    }
  }

  .gray-navbar-items > div,
  .navbar-link-container {
    border-bottom: 1px solid $gray-300;

    &:first-child {
      border-top: 1px solid $gray-300;
    }
  }

  .navbar-items {
    & > div:hover > span {
      font-weight: bold !important;
    }
  }

  .profile-section {
    border-bottom-right-radius: 16px;
  }

  .target-text {
    line-height: 1.25rem;
  }

  .last-sign-in-at {
    margin-top: 0.25rem;
    font-size: 0.75rem;
  }

  .target-icon {
    width: 2.5rem;
    height: 2.5rem;
    & > img {
      height: 1.5rem;
      @include recolor-icon;
    }
  }
}
</style>
